import { render, staticRenderFns } from "./search_zhifu.vue?vue&type=template&id=2875186d&scoped=true&"
import script from "./search_zhifu.vue?vue&type=script&lang=js&"
export * from "./search_zhifu.vue?vue&type=script&lang=js&"
import style0 from "./search_zhifu.vue?vue&type=style&index=0&id=2875186d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2875186d",
  null
  
)

export default component.exports